
// Base.
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'

// Used Models.
import { User } from '../../models/user'
import AdService from '@/services/ServiceService'
import UserService from '@/services/UserService'

import Service from '@/models/service'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'

@Component({
  components: {
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class AssignService extends Mixins(usersMixins) {
  private services: any[] = []
  private selectedServices: any[] = []

  @Prop() private readonly getJsonData!: User[]

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private async save() {
    const services = this.selectedServices
    const users = this.getJsonData

    // TODO: call back-end to assign services to selected users.

    UserService.assignServicesToUsers(services, users).then((response: any) => {
      // res.forEach((service: Service) => {
      //   this.services.push(service);
      // });
    })
  }

  private initialize() {
    AdService.get().then((res: Service[]) => {
      res.forEach((service: Service) => {
        this.services.push(service)
      })
    })
  }

  private close() {
    this.isPending = false
    this.dialog = false
  }
}
